import { toast } from 'react-toastify';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import {
    fetchGstr3bDataService,
    fetchGstReturnSummaryService,
    fetchRevenueVendorExpenseTableDataService,
    getGstReportsService,
    generateGstAnalysisReportService,
} from './revenueVendorExpensesService';
import { Handlers } from '../../../types/actions/types';
import { GstAnalysisReportMeta, GstRangeParams, GstReturnSummaryRequest, GstReturnSummaryResponseBody } from './types';

export async function fetchRevenueVendorExpenseTableData(payload, handlers: Handlers) {
    try {
        const response = await fetchRevenueVendorExpenseTableDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return;
            case JAVA_API_STATUS.ERROR:
                return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}

export async function fetchGstr3bData(payload, handlers: Handlers) {
    try {
        const response = await fetchGstr3bDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return response?.data?.responseBody;
            case JAVA_API_STATUS.ERROR:
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}

// Request carries orgId + view + the applied range (buildGstRangeParams in utils/dateUtils).
// onSuccess receives responseBody ({ gstReturnSummary, gstConnectionStatus }); a non-success response,
// a missing body and a transport error all call onError, so the caller can tell a failed fetch from an empty one.
export async function fetchGstReturnSummary(payload: GstReturnSummaryRequest, handlers: Handlers) {
    try {
        const response = await fetchGstReturnSummaryService(payload);
        const responseBody: GstReturnSummaryResponseBody | undefined = response.data?.responseBody;
        if (response.data?.responseData?.responseCode !== JAVA_API_STATUS.SUCCESS || !responseBody) return handlers?.onError?.();
        handlers?.onSuccess?.(responseBody);
    } catch (err) {
        handlers?.onError?.(err);
    }
}

// rangeParams: the applied GST "Time Period" range (buildGstRangeParams in utils/dateUtils).
// Omitted/empty means
// the backend keeps using its own derived range, i.e. today's unfiltered report.
export async function generateGstAnalysisReport(orgId: string, rangeParams: GstRangeParams = {}): Promise<GstAnalysisReportMeta | null> {
    try {
        const response = await generateGstAnalysisReportService({ orgId, ...rangeParams });
        const data = response?.data?.data;
        if (data?.mnemosyneDocId) {
            return { mnemosyneDocId: data.mnemosyneDocId, fileName: data.fileName };
        }
        toast.error('Failed to generate GST Analysis Report');
        return null;
    } catch (err) {
        toast.error('Failed to generate GST Analysis Report');
        return null;
    }
}

export async function getGSTReports(payload, handlers: Handlers) {
    try {
        const response = await getGstReportsService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.gstReports || []);
                return response?.data?.gstReports || [];
            case JAVA_API_STATUS.ERROR:
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}
